import { Box, TextField } from "@mui/material";
import { TitleSection } from "../../components/TitleSection";
import { VerticalSlider } from "../../components/sliderPage/verticalSlider";

export const SecContactMe = () => {
  return (
    <>
      <VerticalSlider />
      <Box
        id={"contact-me"}
        sx={{
          paddingX: {
            xs: "25px",
            sm: "50px",
            md: "70px",
          },

          mt: 3,
        }}
      >
        <Box sx={{ mb: "20px" }}>
          <TitleSection title={"Contact Me"} value={75} />
        </Box>
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              flexDirection: {
                xs: "column",
                md: "row",
              },
              display: "flex",
              height: "450px",
              mt: 5,
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                pb: {
                  xs: 2,
                  md: 0,
                },
              }}
            >
              <Box
                alt={"image-preview"}
                sx={{
                  height: "300px",
                  width: "300px",
                  //p: "20px 20px 0 20px",
                  boxShadow: "var(--c-box-shadow-inset-btn)",
                  backgroundColor: "var(--c-bg-content-color)",
                  borderRadius: 4,
                  objectFit: "contain",
                }}
                component="img"
                src={"/img/icomp.webp"}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                flexDirection: "column",
                gap: 4,
                display: "flex",
                "& .MuiFormControl-root": {
                  backgroundColor: "var(--c-bg-content-color)",
                  boxShadow: "var(--c-box-shadow-inset-btn)",
                },
                "& .MuiFormLabel-root": {
                  color: "gray",
                  fontWeight: "bold",
                },
                "& .MuiInputBase-input": {
                  border: "0px",
                },
                "& .Mui-focused.MuiFormLabel-root": {
                  p: "5px",
                  borderRadius: 3,
                  backgroundColor: "var(--c-main-color)",
                  boxShadow: "var(--c-box-shadow-btn)",
                },
                "& .Mui-focused.MuiInputBase-root": {
                  backgroundColor: "var(--c-main-color)",
                },
                "input:focus": {
                  outline: "none",
                },
              }}
            >
              <Box>
                <TextField
                  fullWidth
                  disabled
                  id="outlined-basic"
                  label="Name*"
                  variant="outlined"
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  disabled
                  id="outlined-basic"
                  label="Email ID*"
                  variant="outlined"
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  disabled
                  id="standard-multiline-static"
                  label="Message*"
                  multiline
                  rows={4}
                  variant="standard"
                  sx={{
                    "& .MuiFormLabel-root": {
                      ml: "15px",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
